// extracted by css-extract-rspack-plugin
export default {"root":"Paper-module__root___J7aUr"};